const POST_LOGIN_REDIRECT_STORAGE_KEY = "admin:post-login-redirect";

const isInternalPath = (path: string): boolean =>
  path.startsWith("/") && !path.startsWith("//");

export function rememberPostLoginRedirect(path: string): void {
  if (!isInternalPath(path)) return;

  try {
    window.sessionStorage.setItem(POST_LOGIN_REDIRECT_STORAGE_KEY, path);
  } catch {
    // sessionStorage が利用できない環境では、従来どおりホームへ遷移する。
  }
}

export function consumePostLoginRedirect(): string {
  try {
    const path = window.sessionStorage.getItem(POST_LOGIN_REDIRECT_STORAGE_KEY);
    window.sessionStorage.removeItem(POST_LOGIN_REDIRECT_STORAGE_KEY);
    return path && isInternalPath(path) ? path : "/";
  } catch {
    return "/";
  }
}
